import MultipleChoiceRepeaterItem from './MultipleChoiceRepeaterItem';

export default MultipleChoiceRepeaterItem;
